(function(){
  'use strict';
  var VERSION = 'p11dz401-v25-social-forensics';
  var last = null;

  function qsa(sel, root){ try { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); } catch(e){ return []; } }
  function attr(node, name){ return node && node.getAttribute ? node.getAttribute(name) || '' : ''; }
  function countBy(nodes, name){
    var map = {};
    nodes.forEach(function(node){
      var value = attr(node, name);
      if (!value) return;
      map[value] = (map[value] || 0) + 1;
    });
    return Object.keys(map).filter(function(k){ return map[k] > 1; }).map(function(k){ return { key:k, count:map[k] }; });
  }
  function scriptText(){
    return qsa('script').map(function(s){ return s.src || s.textContent || ''; }).join('\n');
  }
  function staleFirebasePaths(text){
    var checks = ['DSDSample', 'postComments/', 'postReactions/', 'reactions/{reactionId}', 'profiles/{profileKey}/followers', 'members/{memberId}', 'localStorageCanonical:true'];
    return checks.filter(function(term){ return text.indexOf(term) !== -1; });
  }
  function zIndexRisks(){
    var out = [];
    ['#star-background', '#MainContent', '.dsd-social-nav397', '.section-header', '[data-dsd-user-profile]', '[data-dsd-surface="moderation-center"]'].forEach(function(sel){
      var node = document.querySelector(sel);
      if (!node) return;
      var style = window.getComputedStyle ? window.getComputedStyle(node) : {};
      out.push({ selector: sel, zIndex: style.zIndex || 'auto', position: style.position || 'static', hidden: style.display === 'none' || style.visibility === 'hidden' });
    });
    return out;
  }
  function hiddenLegacyBlocks(){
    return qsa('[class*="legacy"], [id*="legacy"], [data-dsd-contract*="legacy"], [class*="placeholder"], [data-dsd-placeholder], [class*="sample"], [data-sample]').map(function(node){
      return { tag: node.tagName, id: node.id || '', className: String(node.className || '').slice(0, 160), owner: attr(node, 'data-dsd-owner') };
    }).slice(0, 80);
  }
  function routeTemplateDrift(){
    var routes = window.DSDSocialRoutes || {};
    var expected = ['usersPath','profilePath','feedPath','followingPath','notificationsPath','messagesPath','storiesPath'];
    return expected.filter(function(key){ return !routes[key]; });
  }
  function wasabiRisks(text){
    var risks = [];
    if (/private-videos\\\\|profiles\\\\|posts\\\\|stories\\\\/.test(text)) risks.push('backslash-path-convention');
    if (text.indexOf('signedUrlRequired') === -1 && text.indexOf('mediaManifests') !== -1) risks.push('media-manifest-without-signed-url-flag');
    return risks;
  }
  function activeLegacyScripts(text){
    var retired = [
      'dsd-post-renderer.js',
      'dsd-feed-renderer.js',
      'dsd-comment-renderer.js',
      'dsd-reaction-renderer.js',
      'dsd-canonical-post-store.js',
      'dsd-canonical-feed-hydrator.js',
      'dsd-post-composer-controller.js',
      'dsd-social-persistence-layer-p11dz387.js',
      'dsd-firebase-post-read-adapter-p11dz164.js',
      'dsd-social-core-v1.js'
    ];
    return retired.filter(function(name){ return text.indexOf(name) !== -1; });
  }
  function themeAssetDrift(){
    var shopifyTheme = (window.Shopify && window.Shopify.theme) || {};
    var assetThemeIds = {};
    qsa('script[src], link[href], img[src], source[src]').forEach(function(node){
      var url = attr(node, 'src') || attr(node, 'href');
      var match = String(url || '').match(/\/cdn\/shop\/t\/(\d+)\//);
      if (match) assetThemeIds[match[1]] = (assetThemeIds[match[1]] || 0) + 1;
    });
    var ids = Object.keys(assetThemeIds);
    var risks = [];
    if (ids.length > 1) risks.push('mixed-cdn-theme-assets');
    if (shopifyTheme.id && ids.length && ids.indexOf(String(shopifyTheme.id)) === -1) risks.push('shopify-theme-id-not-in-cdn-assets');
    if (shopifyTheme.name && /operational-launch-ready-patched-20260616/i.test(shopifyTheme.name)) risks.push('old-published-theme-response');
    return {
      shopifyThemeName: shopifyTheme.name || '',
      shopifyThemeId: shopifyTheme.id || '',
      assetThemeIds: ids.map(function(id){ return { id:id, count:assetThemeIds[id] }; }),
      previewThemeId: new URLSearchParams(location.search || '').get('preview_theme_id') || '',
      risks: risks
    };
  }
  function firebaseBridgeDrift(){
    var b = window.DSDFirebaseBridge || {};
    var launch = window.DSDLaunchSocial && window.DSDLaunchSocial.snapshot ? window.DSDLaunchSocial.snapshot() : null;
    var risks = [];
    if (!b.projectId || b.projectId !== 'dsd-video-counter') risks.push('firebase-project-id-mismatch');
    if (b.tokenEndpoint !== '/apps/dsd-firebase-custom-token') risks.push('token-endpoint-drift');
    if (!b.auth || !b.db || !b.firestore) risks.push('firebase-sdk-bridge-not-ready');
    if (launch && launch.localStorageCanonical !== false) risks.push('local-storage-canonical-drift');
    return { projectId: b.projectId || '', tokenEndpoint: b.tokenEndpoint || '', bridgeReady: !!(b.auth && b.db && b.firestore), risks: risks };
  }
  function invariantChecks(){
    return {
      shootingStars: !!document.getElementById('star-background'),
      socialNav: !!document.querySelector('.dsd-social-nav397'),
      commerceAccess: !!document.querySelector('.dsd-social-nav397 a[href*="/collections"], .dsd-social-nav397 a[href*="/cart"], a[href*="/collections/all"]'),
      profileAccess: !!document.querySelector('.dsd-social-nav397 a[href*="/pages/user-profile"], .dsd-social-nav397 a[href*="/account"]'),
      notificationBell: !!document.querySelector('[data-dsd-notification-bell]')
    };
  }
  function socialNavigationDrift(){
    var socialRoute = document.documentElement.classList.contains('dsd-social-route') || document.body && document.body.classList.contains('dsd-social-page');
    var iconBars = qsa('#icon-bar2, .icon-bar2, .icon-bar');
    var shopifyHeaders = qsa('.shopify-section-group-header-group, .section-header, sticky-header, .header-wrapper');
    var visibleHeaders = shopifyHeaders.filter(function(node){
      var style = window.getComputedStyle ? window.getComputedStyle(node) : {};
      return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
    });
    var visibleIconBars = iconBars.filter(function(node){
      var style = window.getComputedStyle ? window.getComputedStyle(node) : {};
      return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
    });
    return {
      socialRoute: !!socialRoute,
      owner: window.DSDSocialNavigationOwner || '',
      dockCount: qsa('.dsd-social-nav397__dock').length,
      socialNavCount: qsa('.dsd-social-nav397').length,
      legacyIconBarCount: iconBars.length,
      visibleLegacyIconBars: visibleIconBars.length,
      visibleStorefrontHeaders: visibleHeaders.length,
      slickLoaded: !!(window.jQuery && window.jQuery.fn && window.jQuery.fn.slick),
      risks: [
        socialRoute && qsa('.dsd-social-nav397').length !== 1 ? 'social-nav-count-drift' : '',
        socialRoute && visibleIconBars.length ? 'legacy-icon-bar-visible-on-social-route' : '',
        socialRoute && visibleHeaders.length ? 'storefront-header-visible-on-social-route' : '',
        socialRoute && window.jQuery && window.jQuery.fn && window.jQuery.fn.slick ? 'slick-loaded-on-social-route' : ''
      ].filter(Boolean)
    };
  }
  function cssConflictRisks(){
    var risks = [];
    qsa('[data-dsd-surface], [data-dsd-user-profile], #dsd-feed-container, [data-dsd-mv395]').forEach(function(node){
      var style = window.getComputedStyle ? window.getComputedStyle(node) : {};
      if (style.display === 'none' || style.visibility === 'hidden') {
        risks.push({ selector: node.id ? '#' + node.id : node.tagName.toLowerCase(), owner: attr(node, 'data-dsd-owner'), reason: 'hidden-social-surface' });
      }
      if (style.position === 'absolute' && parseInt(style.zIndex || '0', 10) < 1) {
        risks.push({ selector: node.id ? '#' + node.id : node.tagName.toLowerCase(), owner: attr(node, 'data-dsd-owner'), reason: 'absolute-low-z-index' });
      }
    });
    return risks.slice(0, 50);
  }
  function scan(){
    var owners = qsa('[data-dsd-owner]');
    var renderers = qsa('[data-dsd-renderer]');
    var controllers = qsa('[data-dsd-controller]');
    var text = scriptText();
    last = {
      version: VERSION,
      scannedAt: new Date().toISOString(),
      route: location.pathname,
      duplicateOwners: countBy(owners, 'data-dsd-owner'),
      duplicateRenderers: countBy(renderers, 'data-dsd-renderer'),
      duplicateControllers: countBy(controllers, 'data-dsd-controller'),
      hiddenLegacyBlocks: hiddenLegacyBlocks(),
      zIndex: zIndexRisks(),
      staleFirebasePaths: staleFirebasePaths(text),
      wasabiRisks: wasabiRisks(text),
      activeLegacyScripts: activeLegacyScripts(text),
      themeAssetDrift: themeAssetDrift(),
      firebaseBridge: firebaseBridgeDrift(),
      invariants: invariantChecks(),
      socialNavigation: socialNavigationDrift(),
      cssConflictRisks: cssConflictRisks(),
      missingRoutes: routeTemplateDrift(),
      canonicalSocial: !!window.DSDLaunchSocial,
      launchSocial: window.DSDLaunchSocial && window.DSDLaunchSocial.snapshot ? window.DSDLaunchSocial.snapshot() : null
    };
    try {
      var registry = window.DSDRegistry || window.DSDRuntimeRegistry;
      if (registry && registry.claim) registry.claim('social-forensics:v25', 'SocialForensicsV25', last);
      window.dispatchEvent(new CustomEvent('dsd:social-forensics:report', { detail:last }));
    } catch(e) {}
    return last;
  }
  function schedule(){
    if (window.requestIdleCallback) window.requestIdleCallback(scan, { timeout: 1800 });
    else setTimeout(scan, 700);
  }
  window.DSDSocialForensics397 = { version: VERSION, scan: scan, snapshot: function(){ return last || scan(); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once:true });
  else schedule();
})();
